
import ShapeEven from '@/assets/svg/icons/shape-even.svg';
import Vue from 'vue';
import { TransformedCmBenefits } from '~/transforms/transformModules';

export default Vue.extend({
  props: {
    data: {
      type: Object as () => TransformedCmBenefits['data'],
      required: true,
    },
  },
  computed: {
    moduleHeadline(): {
      text: string | undefined;
      level: string;
      fontStyle: string;
    } {
      return {
        text: this.data.headline,
        level: 'h2',
        fontStyle: 'h2',
      };
    },
  },
  methods: {
    checkHeadlineMargin() {
      const headlineText = this.data.headline?.trim() ?? '';
      if (headlineText.length === 0) {
        return 'no-margin-top';
      }
    },
  },
  components: { ShapeEven },
});
